import { render, staticRenderFns } from "./FridgeDevice.vue?vue&type=template&id=2a4348ec&"
import script from "./FridgeDevice.vue?vue&type=script&lang=js&"
export * from "./FridgeDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports